import { render, staticRenderFns } from "./techprocessesEditWasteForm.vue?vue&type=template&id=38e78480&scoped=true"
import script from "./techprocessesEditWasteForm.vue?vue&type=script&lang=js"
export * from "./techprocessesEditWasteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e78480",
  null
  
)

export default component.exports